import { render, staticRenderFns } from "./stocking.vue?vue&type=template&id=67bfe980"
import script from "./stocking.vue?vue&type=script&lang=js"
export * from "./stocking.vue?vue&type=script&lang=js"
import style0 from "./stocking.vue?vue&type=style&index=0&id=67bfe980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports